import { Component, ViewEncapsulation } from '@angular/core';
import { DataLoaderService } from '../../services/data-loader.service';

@Component({
  selector: 'app-data-loader',
  templateUrl: './data-loader.component.html',
  styleUrls: ['./data-loader.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class DataLoaderComponent {
  constructor(public dataloader: DataLoaderService) {}
}
